module.exports = __webpack_public_path__ + "static/img/twipro2.f258eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/twipro2.jpg
// module id = t3q7
// module chunks = 0